(function(){
  var root = document.querySelector('.rev-by');
  if(!root) return;

  var unit = parseInt(root.dataset.unit, 10) || 0;            /* cents */
  var variantId = parseInt(root.dataset.variant, 10);

  /* Derive currency style from a Liquid-rendered sample of 100 cents, rather than parsing
     shop.money_format here — that would need a literal double-brace, which cannot appear
     inside a section javascript block. */
  var sample = root.dataset.moneySample || '$1.00';
  var sym = sample.replace(/[0-9.,\s]/g, '');
  var withDecimals = /[.,]\d\d/.test(sample);
  function money(cents){
    var n = cents / 100;
    return sym + (withDecimals ? n.toFixed(2) : String(Math.round(n)));
  }

  /* ---- gallery ---- */
  var main = root.querySelector('.rev-by__main');
  root.querySelectorAll('.rev-by__thumb').forEach(function(t){
    t.addEventListener('click', function(){
      if(main && t.dataset.full) main.src = t.dataset.full;
      root.querySelectorAll('.rev-by__thumb').forEach(function(o){ o.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---- countdown to end of today, so it can never show a negative ---- */
  var hEl = root.querySelector('[data-by-hrs]'), mEl = root.querySelector('[data-by-min]'), sEl = root.querySelector('[data-by-sec]');
  function pad(n){ return n < 10 ? '0'+n : ''+n; }
  function tick(){
    var now = new Date();
    var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    var d = Math.max(0, Math.floor((end - now)/1000));
    if(hEl) hEl.textContent = pad(Math.floor(d/3600));
    if(mEl) mEl.textContent = pad(Math.floor((d%3600)/60));
    if(sEl) sEl.textContent = pad(d%60);
  }
  tick(); setInterval(tick, 1000);

  /* keep the slider track vertically centered on the tier dots at any breakpoint */
  function alignTrack(){
    var row = root.querySelector('.rev-by__tier-row');
    var track = root.querySelector('.rev-by__track');
    var dot = root.querySelector('.rev-by__tier-dot');
    if(!row || !track || !dot) return;
    var top = dot.getBoundingClientRect().top - row.getBoundingClientRect().top + dot.offsetHeight / 2 - track.offsetHeight / 2;
    track.style.top = top + 'px';
  }
  alignTrack();
  window.addEventListener('resize', alignTrack);

  /* ---- bundle tiers + blend picker share one quantity state ---- */
  var tiers = [].slice.call(root.querySelectorAll('[data-by-tier]'));
  var fill  = root.querySelector('[data-by-fill]');
  var atc   = root.querySelector('[data-by-atc]');
  var oncePriceEl = root.querySelector('[data-by-once-price]');
  var target = 1, added = 0, mode = 'once';

  function tierFor(qty){
    var best = tiers[0];
    tiers.forEach(function(t){ if(parseInt(t.dataset.qty,10) <= qty) best = t; });
    return best;
  }

  function render(){
    var effective = added > 0 ? added : target;
    var active = tierFor(effective);
    tiers.forEach(function(t){ t.classList.toggle('is-active', t === active); });

    var idx = tiers.indexOf(active);
    if(fill) fill.style.width = (idx/(tiers.length-1)*100) + '%';

    var off = parseInt(active.dataset.off, 10) || 0;
    var ea  = Math.round(unit * (100-off) / 100);
    if(oncePriceEl) oncePriceEl.textContent = money(ea) + '/ea';

    if(added < 1){
      atc.disabled = true;
      atc.classList.add('is-disabled');
      atc.textContent = 'Select At Least 1 Jar';
    } else {
      atc.disabled = false;
      atc.classList.remove('is-disabled');
      var perEa = mode === 'sub' ? Math.round(unit * 0.7) : ea;
      atc.textContent = (mode === 'sub' ? 'Subscribe — ' : 'Add ' + added + ' Jar' + (added>1?'s':'') + ' — ')
                        + money(perEa * added);
    }
  }

  tiers.forEach(function(t){
    t.addEventListener('click', function(){
      target = parseInt(t.dataset.qty, 10) || 1;
      render();
    });
  });

  /* ---- blend rows: Add + fills the bundle ---- */
  root.querySelectorAll('[data-by-row]').forEach(function(row){
    var btn = row.querySelector('[data-by-add]');
    var n = 0;
    btn.addEventListener('click', function(){
      n++; added++;
      row.classList.add('is-added');
      btn.classList.add('is-on');
      btn.innerHTML = 'Added ' + n + ' <span>+</span>';
      render();
    });
  });

  /* hide the "scroll for more" bar once the list is at the bottom */
  var scroller = root.querySelector('.rev-by__picker-scroll');
  var moreBar  = root.querySelector('[data-by-more]');
  if(scroller && moreBar){
    var syncMore = function(){
      var atEnd = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 4;
      moreBar.classList.toggle('is-hidden', atEnd);
    };
    scroller.addEventListener('scroll', syncMore, {passive:true});
    syncMore();
  }

  /* ---- purchase mode (presentational: no selling plan exists on this store) ---- */
  var modes = [].slice.call(root.querySelectorAll('.rev-by__mode'));
  modes.forEach(function(el){
    el.addEventListener('click', function(){
      modes.forEach(function(o){ o.classList.remove('is-active'); });
      el.classList.add('is-active');
      var input = el.querySelector('input'); if(input) input.checked = true;
      mode = el.dataset.byMode;
      render();
    });
  });

  /* ---- flavour chips drive the three detail cards ---- */
  /* The seven flavours that have real jar photography. Each chip also carries the image
     URL in data-by-img, so selecting one swaps the first detail card to that jar. */
  var FLAVOUR = {
    'Wild Elderberry':  ['Sambucus nigra fruit extract 100 mg, zinc citrate 10 mg.', 'Deep and jammy with a clean finish and no medicinal edge.', 'The default. Tastes like fruit, not like a supplement.'],
    'Blackcurrant':     ['Same 100 mg elderberry base, blackcurrant natural flavour.', 'Tart and grown-up, with a dry cassis snap at the end.', 'For adults who find most gummies cloying.'],
    'Black Cherry':     ['Same base, dark cherry natural flavour.', 'Rounder and sweeter — the one children ask for by name.', 'The easiest sell in the house.'],
    'Citrus Burst':     ['Same base, blood orange and lemon natural flavour.', 'Bright and sharp. A wake-up flavour for the morning jar.', 'Feels like the start of the day rather than a chore.'],
    'Pomegranate':      ['Same base, pomegranate natural flavour.', 'Sharp and clean with a faint tannic bite.', 'The most refreshing of the range.'],
    'Peach Blossom':    ['Same base, white peach natural flavour.', 'Soft and floral — the gentlest option in the range.', 'For anyone put off by tart flavours entirely.'],
    'Blue Raspberry':   ['Same base, blue raspberry natural flavour.', 'Unapologetically fun, with the same 10 mg of zinc underneath.', 'The one that gets a nine-year-old on board.']
  };
  var findEls = [
    root.querySelector('[data-by-find="0"]'),
    root.querySelector('[data-by-find="1"]'),
    root.querySelector('[data-by-find="2"]')
  ];
  function paintBlend(name){
    var d = FLAVOUR[name] || FLAVOUR['Wild Elderberry'];
    findEls.forEach(function(el, i){ if(el) el.textContent = d[i]; });
  }
  var flavImg = root.querySelector('[data-by-flavimg]');
  root.querySelectorAll('[data-by-chip]').forEach(function(chip){
    chip.addEventListener('click', function(){
      root.querySelectorAll('[data-by-chip]').forEach(function(o){ o.classList.remove('is-active'); });
      chip.classList.add('is-active');
      paintBlend(chip.dataset.byChip);
      if(flavImg && chip.dataset.byImg){
        flavImg.src = chip.dataset.byImg;
        flavImg.alt = chip.dataset.byChip + ' flavour';
      }
    });
  });
  paintBlend('Wild Elderberry');

  /* ---- add to cart (JS API, so the Kaching apps can't hijack a form) ---- */
  atc.addEventListener('click', function(){
    if(atc.disabled || !variantId) return;
    var label = atc.textContent;
    atc.disabled = true;
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: variantId, quantity: added })
    })
    .then(function(r){ return r.json(); })
    .then(function(){ window.themeGoToCheckout(); })
    .catch(function(){ atc.disabled = false; atc.textContent = label; });
  });

  render();
})();
